import appStore from 'store';
import api from './api';
import { PAGINATION } from './constants';

const store = {
  namespaced: true,
  state: {
    auditList: [],
    activeTab: 'unaudited',
    detailDialogVisible: false,
    auditDetail: {},
    pagination: PAGINATION,
    totalCount: 0,
    coinList:[],
    totalInfo:{}
  },
  mutations: {
    setAuditList(state, payload) {
      state.auditList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setpage(state, page) {
      state.pagination = page;
    },
    setCoinList(state,payload){
      state.coinList=payload
    },
    setTotalInfo(state,payload){
      state.totalInfo=payload
    }
  },
  actions: {
    gethashList({ commit }, query) {
      api.gethashList(query).then(({ data }) => {
        commit('setAuditList', data);
      });
    },
    getTotalInfo({ commit }, query) {
      api.getTotalInfo(query).then(({ data }) => {
        commit('setTotalInfo', data);
      });
    },
    getAllCoins({commit},data){
      api.getAllCoins(data).then(res=>{
        console.log('cin',res);
        if(res.code==0){
          commit('setCoinList',res.data)
        }
      })
    }
  }
};

appStore.registerModule('withrawRecord', store);
